import returnFetch, { type ReturnFetchDefaultOptions } from 'return-fetch';
import { checkIsMobile } from '../checkIsMobile';

export const customReturnFetch = (args?: ReturnFetchDefaultOptions) => {
  const isMobile = checkIsMobile();
  const defaultHeaders: HeadersInit = {
    Accept: '*/*',
    'Accept-Language': 'ko',
    'X-Device-Info': JSON.stringify({
      t: isMobile ? 'webMobile' : 'webPc',
      v: '1.0',
      ui: 0,
    }),
  };

  return returnFetch({
    ...args,
    headers: { ...defaultHeaders, ...args?.headers },
    fetch(input, init) {
      const shouldDefaultToNoCache = init?.cache == null && init?.next == null;
      return fetch(input, {
        ...init,
        ...(shouldDefaultToNoCache ? { cache: 'no-cache' } : null),
      });
    },
  });
};
